import { OptionsType, OptionType } from '@lendi-ui/dropdown';

import { ADDITIONAL_INCOME_TYPE_OPTIONS, FIELD_PATHS } from '@funnels/constants';
import { IncomeEntityIndex } from '@funnels/types';

import { DropdownField, StringDisplay } from '../../Fields';
import { EditableViewProps, StringReadOnlyViewProps } from '../types';

export interface IncomeTypeEditableViewProps extends EditableViewProps, IncomeEntityIndex {
  disableFailMessage?: boolean;
  options?: OptionsType<OptionType>;
  onChange: (values: string[]) => void;
}
export const IncomeTypeEditableView = (props: IncomeTypeEditableViewProps) => {
  const { incomeIndex, options = ADDITIONAL_INCOME_TYPE_OPTIONS, disableFailMessage, isDisabled, onChange } = props;

  return (
    <DropdownField
      name={FIELD_PATHS.INCOME_TYPE(incomeIndex)}
      options={options}
      disableFailMessage={disableFailMessage}
      isDisabled={isDisabled}
      onChange={onChange}
      isFullWidth
      shouldAnchorList
    />
  );
};

interface IncomeTypeFunnelViewProps extends IncomeEntityIndex {
  onChange: (values: string[]) => void;
}

export function IncomeTypeFunnelView(props: IncomeTypeFunnelViewProps) {
  const { incomeIndex, onChange, ...rest } = props;
  return (
    <DropdownField
      {...rest}
      label="Type"
      name={FIELD_PATHS.INCOME_TYPE(incomeIndex)}
      onChange={onChange}
      options={ADDITIONAL_INCOME_TYPE_OPTIONS}
    />
  );
}

export const IncomeTypeFunnelReadOnlyView = (props: StringReadOnlyViewProps) => <StringDisplay {...props} />;
